import { useEffect, useState, SetStateAction, useRef, useLayoutEffect } from 'react'

import { CloseIcon } from '@Static/icons/ArrowIcons'
import ReactModal from 'react-modal'

import { ModalTypes } from '../modalTypes'

import cls from './ModalWrapper.module.scss'

export default function ModalWrapper({
  isOpen = false,
  setIsOpen,
  children = null,
  timeOutModal = 0,
  styles = null,
  showCloseIcon = false,
  parent,
}: ModalTypes) {
  const [scrollBarWidth, setScrollBarWidth] = useState<SetStateAction<number | null>>(null)
  const [contentNode, setContentNode] = useState<HTMLDivElement | null>(null)

  const modalRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    function getScrollBarWidth() {
      if (!document.body.classList.contains('overflow'))
        setScrollBarWidth(window.innerWidth - document.body.offsetWidth)
    }

    getScrollBarWidth()
    window.addEventListener('resize', getScrollBarWidth)

    return () => {
      window.removeEventListener('resize', getScrollBarWidth)
    }
  }, [isOpen])

  useEffect(() => {
    if (!isOpen || !contentNode) return

    const handleContentClick = (e: MouseEvent) => {
      if (e.target === contentNode) {
        setIsOpen()
      }
    }

    contentNode.addEventListener('mousedown', handleContentClick)
    return () => {
      contentNode.removeEventListener('mousedown', handleContentClick)
    }
  }, [isOpen, contentNode])

  ReactModal.setAppElement('body')

  const customStyles = () => {
    const defaultStyles = {
      overlay: {
        top: '0',
        left: '0',
        zIndex: '500',
        width: '100%',
        height: '100%',
        background: 'unset',
        overflow: 'hidden auto',
      },
      content: {
        inset: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '0',
        border: 'unset',
        minHeight: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '0',
      },
    }

    const overlay = { ...defaultStyles?.overlay, ...styles?.overlay }
    const content = { ...defaultStyles?.content, ...styles?.content }

    return { ...defaultStyles, overlay, content }
  }

  let parentSelector
  if (parent) {
    parentSelector = () => parent
  }

  return (
    <ReactModal isOpen={isOpen} style={customStyles()} parentSelector={parentSelector} contentRef={setContentNode}>
      <div ref={modalRef} className={cls.container}>
        {children}
        {showCloseIcon ? <CloseIcon onClick={setIsOpen} className={cls.closeIcon} /> : null}
      </div>
    </ReactModal>
  )
}
